import React, { useState, useEffect, useRef } from "react";
import cn from "classnames";
import axios from "axios";
import styles from "./Index.module.sass";
import Card from "../../components/Card";
import Form from "../../components/Form";
import Panel from "./Panel";
import OrderLineItems from "./OrderLineItems/index";
import { Divider, message } from "antd";
import {
  FETCH_ORDER_DETAILS,
  GET_CAMERAS,
  GET_ALL_CAMERA_SETTINGS,
  GENERATE_ORDER_MEDIA_PRESIGNEDURL,
  UPLOAD_ORDER_MEDIA_METADATA,
  DELETE_ALL_ORDER_MEDIA,
  DELETE_SINGELORDER_MEDIA,
  PACK_ORDERS,
  GET_TAG_BY_ACTION_BARCODE,
  UPDATE_WAREHOUSE_LOCATION,
  GET_DEFAULT_LOCATION,
  GET_VARIANT_LOCATION,
  VERIFY_PRODUCTS,
  GET_TOTE_ORDERS,
  GET_AND_ADD_TAG_BY_ACTION_BARCODE,
} from "../../API/Scanner";
import { GET_EMPLOYEE } from "../../API/Employee";
import Product from "./Product";
import Swal from "sweetalert2";
import Record from "../../assets/images/record.png";
import CustomToast from "../../components/CustomToast";
import Loader from "../../components/Loader";
import Image from "../../components/Image";
import errorSound from "../../assets/Sounds/error.wav";
import captureSound from "../../assets/Sounds/capture-beep.mp3";
import successSound from "../../assets/Sounds/Success.wav";
import VideoSound from "../../assets/Sounds/video-beep.mp3";
import CustomAlert from "../../components/CustomAlert";
import { useLocation, useNavigate } from "react-router";
import Dropdown from "../../components/Dropdown";
import Icon from "../../components/Icon";
import CameraPlaceholder from "./Add Camera/CameraPlaceholder";
import UpdateCameraPlaceHolder from "./UpdateCameraPlaceHolder/UpdateCameraPlaceHolder";
import { GET_LOCATIONS } from "../../API/Inventory";
import AccessControl from "../../HOC/AccessControl";
import Modal from "../../components/Modal";
import { get_store_sync_status } from "../../API/Store";

const ScanOrderIndex = () => {
  const showToast = CustomToast();
  const [searchInput, setSearchInput] = useState("");
  const [currentOrder, setCurrentOrder] = useState(null);
  const [productVerified, setProductVerified] = useState([]);
  const [cameras, setCameras] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [capturedPhotos, setCapturedPhotos] = useState([]);
  const [recordedVideos, setRecordedVideos] = useState([]);
  const [activeRecordings, setActiveRecordings] = useState(new Set());
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [scannedBarcode, setScannedBarcode] = useState("");
  const [newcapturedPhotos, setNewCapturedPhotos] = useState([]);
  const [activeBarcode, setActiveBarcode] = useState(null);
  const [canSearchNewOrder, setCanSearchNewOrder] = useState(true);
  const [employee, setEmployee] = useState(null);
  const videoRefs = useRef([]);
  const mediaRecorder = useRef([]);
  const chunks = useRef({});
  const [cameraStreams, setCameraStreams] = useState({});
  const [mediaUploaded, setMediaUploaded] = useState(false);
  const { showAlert } = CustomAlert();
  const errorAudio = useRef(new Audio(errorSound));
  const captureAudio = useRef(new Audio(captureSound));
  const VideoAudio = useRef(new Audio(VideoSound));
  const successAudio = useRef(new Audio(successSound));
  const [recordingStartTime, setRecordingStartTime] = useState(null);
  const recordingTimerRef = useRef(null);
  const alertTimerRef = useRef(null);
  const [isRecording, setIsRecording] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [tagId, setTagId] = useState(null);
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(
    "Select the location"
  );
  const [isLocationSelected, setIsLocationSelected] = useState(false);
  const [isPackingInProgress, setIsPackingInProgress] = useState(false);
  const [cameraUpdateTrigger, setCameraUpdateTrigger] = useState(0);
  const [cameraInitialized, setCameraInitialized] = useState(false);
  const [open, setOpen] = useState(false);
  const [storeStatus, setStoreStatus] = useState(null);
  const [currentToteCode, setCurrentToteCode] = useState(null);

  const handleAddCamera = () => {
    setOpen(false);
    navigate(`/settings`, {
      state: { setting_tab: "Camera" },
    });
  };
  const handleOk = () => {
    setOpen(false)
  }
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isRecording || isPackingInProgress) {
        event.preventDefault();
        const message = isRecording
          ? "Recording in Progress. Are you sure you want to go back? Your recording will be lost."
          : "Packing already in progress. Are you sure you want to move away from this tab?";
        return (event.returnValue = message);
      }
    };
    const handlePopState = (event) => {
      if (isRecording || isPackingInProgress) {
        const message = isRecording
          ? "Recording in Progress. Are you sure you want to go back? Your recording will be lost."
          : "Packing already in progress. Are you sure you want to move away from this tab?";
        const userConfirmed = window.confirm(message);
        if (!userConfirmed) {
          window.history.pushState(null, "", location.pathname);
        }
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);
    const unlisten = () => {
      const originalPushState = window.history.pushState;
      window.history.pushState = function (state, title, url) {
        if (isRecording || isPackingInProgress) {
          const message = isRecording
            ? "Recording in Progress. Are you sure you want to go back? Your recording will be lost."
            : "Packing already in progress. Are you sure you want to move away from this tab?";

          const userConfirmed = window.confirm(message);
          if (!userConfirmed) {
            return;
          }
        }
        originalPushState.apply(this, arguments);
      };
      return () => {
        window.history.pushState = originalPushState;
      };
    };
    const cleanUp = unlisten();
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
      cleanUp();
    };
  }, [isRecording, isPackingInProgress, location.pathname, navigate]);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const data = await GET_EMPLOYEE();
        setEmployee(data);
      } catch (error) {
        console.error("Failed to fetch employees:", error);
      }
    };

    fetchEmployees();
  }, []);

  useEffect(() => {
    const localCamera = localStorage.getItem("Camera");
    const camera = localCamera ? JSON.parse(localCamera) : [];
    if (camera.length === 0) {
      setOpen(true);
    }
    const fetchEmployeeAndInitializeCameras = async () => {
      try {
        const employeeData = await GET_EMPLOYEE();
        setEmployee(employeeData);

        const fetchCamerasAndInitialize = async () => {
          try {
            let storedCameras = JSON.parse(
              localStorage.getItem("Camera") || "[]"
            );
            if (storedCameras.length === 0) {
              const camerasData = await GET_CAMERAS();
              storedCameras = camerasData;
              localStorage.setItem("Camera", JSON.stringify(camerasData));
            }
            setCameras(storedCameras);
            initializeCameras(storedCameras);
          } catch (error) {
            console.error("Error fetching or initializing cameras:", error);
            showToast("Failed to load camera information", "error");
          }
        };

        await fetchCamerasAndInitialize();
      } catch (error) {
        console.error("Failed to fetch employee data:", error);
        showToast("Failed to load employee data", "error");
      }
    };

    fetchEmployeeAndInitializeCameras();

    return () => {
      Object.values(cameraStreams).forEach((stream) => {
        stream.getTracks().forEach((track) => track.stop());
      });
    };
  }, [cameraUpdateTrigger]);

  const initializeCameras = async (camerasToInitialize) => {
    try {
      const streams = {};
      for (const camera of camerasToInitialize) {
        if (!camera.deviceId) {
          console.warn("Camera device ID is undefined or empty");
          continue; 
        }  
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { deviceId: { exact: camera.deviceId } },
        });
  
        const videoTrack = stream.getVideoTracks()[0];
        const capabilities = videoTrack.getCapabilities();
  
        const success = await applyConstraintsWithFallback(videoTrack, capabilities);
        if (!success) {
          console.error(`Failed to apply any constraints for camera: ${camera.deviceId}`);
          showToast("Failed to apply camera constraints", "error");
        }
  
        streams[camera.deviceId] = stream;
      }
      setCameraStreams(streams);
    } catch (error) {
      console.error("Error initializing camera streams:", error);
      showToast("Failed to initialize camera streams", "error");
    }
  };
  const applyConstraintsWithFallback = async (videoTrack) => {
    const idealConstraints = {
      width: { ideal: 1920 },
      height: { ideal: 1080 },
      frameRate: { ideal: 30 },
      aspectRatio: { ideal: 16 / 9 },
    };
    try {
      await videoTrack.applyConstraints(idealConstraints);
      return true; 
    } catch (error) {
      console.warn("Ideal constraints failed:", error);
    }
    const fallbackConstraints = [
      { width: { ideal: 1280 }, height: { ideal: 720 }, frameRate: { ideal: 30 } },
      { width: { ideal: 640 }, height: { ideal: 480 }, frameRate: { ideal: 30 } },
    ];
  
    for (const constraints of fallbackConstraints) {
      try {
        await videoTrack.applyConstraints(constraints);
        return true;
      } catch (error) {
        console.warn("Fallback constraint failed:", constraints, error);
      }
    }
  
    return false; 
  };

  useEffect(() => {
    Object.entries(cameraStreams).forEach(([deviceId, stream]) => {
      const index = cameras.findIndex((camera) => camera.deviceId === deviceId);
      if (index !== -1 && videoRefs.current[index]) {
        videoRefs.current[index].srcObject = stream;
        videoRefs.current[index]
          .play()
          .catch((e) => console.error("Error playing video:", e));
      }
    });
    return () => {
      Object.values(cameraStreams).forEach((stream) => {
        stream.getTracks().forEach((track) => track.stop());
      });
    };
  }, [cameraStreams, cameras]);

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const [storeStatusResponse, locationsData] = await Promise.all([
          get_store_sync_status(),
          GET_LOCATIONS()
        ]);
        setStoreStatus(storeStatusResponse.data);
        setLocations(locationsData);
        setIsLocationSelected(true);
        const defaultLocation = await GET_DEFAULT_LOCATION();
        if (defaultLocation) {
          const defaultLocationObj = locationsData.find(
            loc => loc.location_id === defaultLocation.location_id
          );
          if (defaultLocationObj) {
            setSelectedLocation(defaultLocationObj.name);
            showToast(`Location set to ${defaultLocationObj.name}`, "success");
            return;
          }
        }
        if (locationsData.length === 1) {
          const singleLocation = locationsData[0];
          try {
            await UPDATE_WAREHOUSE_LOCATION(singleLocation.location_id);
            setSelectedLocation(singleLocation.name);
            showToast(`Location set to ${singleLocation.name}`, "success");
          } catch (error) {
            console.error("Error setting default location:", error);
            showToast("Failed to set default location", "error");
          }
        }
      } catch (error) {
        console.error("Error initializing locations:", error);
        showToast("Error loading locations", "error");
      } finally {
        setLoading(false);
      }
    };
    fetchLocations();
  }, []);
  
  const handleLocationChange = async (locationName) => {
    if (locationName === "Select a location") {
      setSelectedLocation("Select a location");
      setIsLocationSelected(false);
    } else {
      const location = locations.find((loc) => loc.name === locationName);
      if (location) {
        try {
          await UPDATE_WAREHOUSE_LOCATION(location.location_id);          
          setSelectedLocation(location.name);
          setIsLocationSelected(true);          
          showToast(`Location set to ${location.name}`, "success");
        } catch (error) {
          console.error("Error updating default location:", error);
          showToast("Failed to set default location", "error");
        }
      }
    }
  };
 

  const handleSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    
    if (!isLocationSelected) {
      showAlert(
        "Location not selected",
        "Please select a location before scanning.",
        "warning",
        "OK",
        null,
        0,
        false,
        false,
        false
      );
      setLoading(false);
      return;
    }
  
    try {
      if (canSearchNewOrder) {
        if (searchInput.startsWith('TOTE')) {
          const response = await GET_TOTE_ORDERS(searchInput);
          if (response.data.result) {
            const toteData = response.data.result;
            if (!toteData || Object.keys(toteData).length === 0) {
              showAlert(
                "Empty Tote",
                "This tote is empty. Please scan a different tote.",
                "warning",
                "OK",
                null,
                0,
                false,
                false,
                false
              );
              errorAudio.current.play();
              return;
            }
            setCurrentToteCode(searchInput);
            const orderData = {
              id: toteData.id,
              order_number: toteData.order_number,
              LineItems: toteData.LineItems,
              OrderMedia: toteData.OrderMedia || [],
              Customer: toteData.Customer || {},
              OrderDetails: toteData.OrderDetails || {},
              Refunds: toteData.Refunds || [],
              ShippingLine: toteData.ShippingLine || [],
              returned_order: toteData.returned_order || false,
              name:toteData.name
            };
  
            setCurrentOrder(orderData);
         
            await copyOrderIdToClipboard(orderData.name); 
            setSelectedProducts([]);
            setCanSearchNewOrder(false);
            setIsPackingInProgress(true);
            showToast(`Order fetched from tote ${searchInput}`, "success");
            successAudio.current.play();
          } else {
            showToast("Invalid tote or no order assigned", "error");
            errorAudio.current.play();
          }
        } else {
          let orderNumber = searchInput;
          if (storeStatus && storeStatus.id === 6) {
            const hyphenIndex = searchInput.indexOf('-');
            if (hyphenIndex !== -1) {
              orderNumber = searchInput.substring(0, hyphenIndex);
            } else {
              orderNumber = searchInput;
            }
          }
          const response = await FETCH_ORDER_DETAILS(orderNumber);
          if (response.status === 200) {
            const orderData = response.data.data;
            setCurrentOrder(orderData);
            setSelectedProducts([]);
            setCanSearchNewOrder(false);
            setIsPackingInProgress(true);
            showToast("Order fetched successfully", "success");
            
            await copyOrderIdToClipboard(orderData.name); 
            successAudio.current.play();
          } else {
            showToast("An error occurred", "error");
            errorAudio.current.play();
          }
        }
      } else {
        if (/^BAR_\d{3}$/.test(searchInput)) {
          await handleCameraMode(searchInput);
        } else if (/^TAG_/.test(searchInput)) {
          try {
            const response = await GET_AND_ADD_TAG_BY_ACTION_BARCODE(currentOrder.id, searchInput);
            if (response.status === 200) {
              const tagData = response.data;
              setTagId(tagData.id);
              showToast(`${tagData.message}`, "success");
              successAudio.current.play();
            } else {
              showToast("Failed to add tag", "error");
              errorAudio.current.play();
            }
          } catch (error) {
            console.error("Error adding tag:", error);
            showToast(error.response?.data?.message || "Error adding tag", "error");
            errorAudio.current.play();
          }
        } else {
          handleSKUScan(searchInput);
        }
      }
    } catch (error) {
      console.error("Error in handleSearch:", error);
      showToast(error.response?.data?.err || "An error occurred", "error");
      errorAudio.current.play();
    } finally {
      setLoading(false);
      setSearchInput("");
    }
  };
  const handleSKUScan = (sku) => {
    const matchingSku = currentOrder.LineItems.find(
      (item) => item.sku === sku || item.barcode === sku
    );
    if (matchingSku) {
      setScannedBarcode(sku);
      showToast(`Scanned SKU: ${matchingSku.name}`, "success");
      successAudio.current.play();
      setTimeout(() => {
        setScannedBarcode("");
      }, 100);
    } else {
      showToast("SKU is not matching", "error");
      errorAudio.current.play();
    }
  };
  const handleCameraMode = async (barcode) => {
    try {
      const cameraResponse = await GET_ALL_CAMERA_SETTINGS();
      if (cameraResponse.status === 200) {
        const camerasData = cameraResponse.data.data;
        let foundCameras =
          camerasData.find((setting) => setting.barcode_value === barcode)
            ?.cameras || [];

        if (foundCameras.length > 0) {
          const camerasToStart = [];
          const camerasToCapture = [];
          const isStoppingRecording = activeBarcode === barcode;

          for (let backendCamera of foundCameras) {
            const localCamera = cameras.find((c) => c.id === backendCamera.id);
            if (!localCamera) continue;
            if (backendCamera.mode === "PHOTO") {
              camerasToCapture.push(localCamera.deviceId);
            } else if (
              backendCamera.mode === "VIDEO" ||
              backendCamera.mode === "BOTH"
            ) {
              if (activeBarcode && barcode !== activeBarcode) {
                showToast(
                  "Cannot start new recording while another is in progress",
                  "error"
                );
                errorAudio.current.play();
                return;
              }
              camerasToStart.push(localCamera.deviceId);
            }
            if (backendCamera.mode === "BOTH" && !isStoppingRecording) {
              camerasToCapture.push(localCamera.deviceId);
            }
          }
          if (camerasToCapture.length > 0 && !isStoppingRecording) {
            capturePhoto(camerasToCapture);
          }
          if (camerasToStart.length > 0) {
            if (isStoppingRecording) {
              await stopAllRecordings();
              setActiveBarcode(null);
              message.warning(`Stopped recording for barcode: ${barcode}`)
              successAudio.current.play();
            } else {
              startRecording(camerasToStart);
              setActiveBarcode(barcode);
              message.success(`Camera mode activated for barcode: ${barcode}`);
            }
          }
        } else {
          showToast(`No cameras found for barcode: ${barcode}`, "error");
          errorAudio.current.play();
        }
      } else {
        setError(
          cameraResponse.data.message || "Error fetching camera settings"
        );
        errorAudio.current.play();
      }
    } catch (err) {
      console.error("Error in handleCameraMode:", err);
      setError("Network error fetching camera settings");
      errorAudio.current.play();
    }
  };
  const stopAllRecordings = async () => {
    const activeDevices = Array.from(activeRecordings);
    if (activeDevices.length > 0) {
      await stopRecording(activeDevices);
    }
  };

  //This is not being used right now
  const addWatermarkToVideo = async (videoBlob) => {
    return new Promise((resolve) => {
      const video = document.createElement("video");
      video.src = URL.createObjectURL(videoBlob);
      video.crossOrigin = "anonymous";
      video.muted = true;
      video.play();

      Swal.fire({
        title: "Processing Video...",
        html:
          '<div style="width: 100%; background: #e0e0e0; border-radius: 8px; margin-top: 10px;">' +
          '<div id="progress-bar" style="height: 20px; width: 0%; background: #76c7c0; border-radius: 8px;"></div>' +
          "</div>",
        toast: true,
        position: "top-right",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      video.onloadedmetadata = () => {
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth || 1920;
        canvas.height = video.videoHeight || 1080;
        const ctx = canvas.getContext("2d");

        const stream = canvas.captureStream(30); // 30 FPS
        const outputRecorder = new MediaRecorder(stream, { mimeType: "video/webm" });
        const outputChunks = [];

        outputRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            outputChunks.push(event.data);
          }
        };

        outputRecorder.onstop = () => {
          const watermarkedBlob = new Blob(outputChunks, { type: "video/webm" });
          Swal.close(); // Close the Swal progress UI
          resolve(watermarkedBlob);
        };

        outputRecorder.start();

        const startTime = Date.now();
        const createdAt = new Date();
        const totalDuration = video.duration || 10; // Fallback to 10s if metadata is missing

        const formatTimestamp = (date) => {
          const hours = date.getHours() % 12 || 12;
          const minutes = date.getMinutes().toString().padStart(2, "0");
          const ampm = date.getHours() >= 12 ? "PM" : "AM";

          return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${hours}:${minutes} ${ampm}`;
        };

        let progress = 0;

        const drawFrame = () => {
          if (video.ended || video.paused) {
            outputRecorder.stop();
            return;
          }

          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

          ctx.font = "12px verdana";
          ctx.shadowColor = "#000";
          ctx.textAlign = "right";
          ctx.lineWidth = 2;//This line width is for strokeText 

          const padding = 20;
          const lineHeight = 30;
          const startY = canvas.height - padding;


          ctx.strokeText(`Created at: ${formatTimestamp(createdAt)}`, canvas.width - padding, startY - lineHeight * 2)
          ctx.strokeText(`By: ${employee.full_name}`, canvas.width - padding, startY - lineHeight)
          ctx.lineWidth = 0; //This line width is for text

          ctx.fillStyle = "#FFFFFF";
          ctx.fillText(`Created at: ${formatTimestamp(createdAt)}`, canvas.width - padding, startY - lineHeight * 2);
          ctx.fillText(`By: ${employee.full_name}`, canvas.width - padding, startY - lineHeight);

          const elapsedTime = Math.floor((Date.now() - startTime) / 1000);
          const formattedTimer = new Date(elapsedTime * 1000).toISOString().substr(11, 8);

          ctx.lineWidth = 2;//This line width is for strok

          ctx.strokeText(`Timer: ${formattedTimer}`, canvas.width - padding, startY)
          ctx.lineWidth = 0; //This line width is for text
          ctx.fillText(`Timer: ${formattedTimer}`, canvas.width - padding, startY);

          progress = Math.min((elapsedTime / totalDuration) * 100, 100);
          document.getElementById("progress-bar").style.width = `${progress}%`;

          requestAnimationFrame(drawFrame);
        };

        drawFrame();
      };
    });
  }

  const capturePhoto = async (cameraIds = []) => {
    const capturePromises = cameras.map(async (camera, index) => {
      if (
        videoRefs.current[index] &&
        (cameraIds.length === 0 || cameraIds.includes(camera.deviceId))
      ) {
        const video = videoRefs.current[index];

        try {
          if ("ImageCapture" in window) {
            const videoTrack = video.srcObject.getVideoTracks()[0];
            const imageCapture = new ImageCapture(videoTrack);
            const bitmap = await imageCapture.grabFrame();
            const canvas = document.createElement("canvas");
            canvas.width = 1920;
            canvas.height = 1080;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
            ctx.font = "bold 24px Arial";
            ctx.fillStyle = "#FFFFFF";
            ctx.textAlign = "left";
            ctx.fillText(` By : ${employee.full_name}`, 20, canvas.height - 20);

            const currentDate = new Date();
            const currentTimestamp = `${currentDate.getDate()}-${
              currentDate.getMonth() + 1
            }-${currentDate.getFullYear()} ${currentDate.getHours()}:${currentDate.getMinutes()} ${
              currentDate.getHours() >= 12 ? "PM" : "AM"
            }`;

            ctx.textAlign = "right";
            ctx.fillText(
              `Time : ${currentTimestamp}`,
              canvas.width - 20,
              canvas.height - 20
            );
            return new Promise((resolve) => {
              canvas.toBlob(
                (blob) => {
                  if (blob) {
                    const newPhoto = {
                      cameraId: camera.deviceId,
                      imageBlob: blob,
                      imageUrl: URL.createObjectURL(blob),
                    };
                    resolve(newPhoto);
                  }
                },
                "image/png",
                1.0
              );
            });
          } else {
            // Fallback to canvas API if ImageCapture is not available
            const canvas = document.createElement("canvas");
            canvas.width = 1920;
            canvas.height = 1080;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            ctx.font = "bold 24px Arial";
            ctx.fillStyle = "#FFFFFF";
            ctx.textAlign = "left";
            ctx.fillText(` By : ${employee.full_name}`, 20, canvas.height - 20);

            const currentDate = new Date();
            const currentTimestamp = `${currentDate.getDate()}-${
              currentDate.getMonth() + 1
            }-${currentDate.getFullYear()} ${currentDate.getHours()}:${currentDate.getMinutes()} ${
              currentDate.getHours() >= 12 ? "PM" : "AM"
            }`;

            ctx.textAlign = "right";
            ctx.fillText(
              `Time : ${currentTimestamp}`,
              canvas.width - 20,
              canvas.height - 20
            );

            return new Promise((resolve) => {
              canvas.toBlob(
                (blob) => {
                  if (blob) {
                    const newPhoto = {
                      cameraId: camera.deviceId,
                      imageBlob: blob,
                      imageUrl: URL.createObjectURL(blob),
                    };
                    resolve(newPhoto);
                  }
                },
                "image/png",
                1.0
              );
            });
          }
        } catch (error) {
          console.error(
            `Error capturing photo for camera ${camera.name}:`,
            error
          );
          return null;
        }
      }
      return null;
    });

    const capturedPhotos = await Promise.all(capturePromises);
    const validPhotos = capturedPhotos.filter((photo) => photo !== null);

    if (validPhotos.length > 0) {
      setCapturedPhotos((prev) => [...prev, ...validPhotos]);
      captureAudio.current.play();
      const mediaData = validPhotos.map((photo) => ({
        cameraId: photo.cameraId,
        type: "image",
        blob: photo.imageBlob,
        fileName: `ppg`,
      }));

      await uploadMedia(mediaData);
    }
  };

  const startRecording = (cameraIds = []) => {
    const kbps = 1024;
    const Mbps = kbps * kbps;
    cameras.forEach((camera, index) => {
      if (
        videoRefs.current[index] &&
        (cameraIds.length === 0 || cameraIds.includes(camera.deviceId))
      ) {
        const stream = videoRefs.current[index].srcObject;
        if (stream && stream.active) {
          if (!mediaRecorder.current[index]) {
            const options = { 
              mimeType: 'video/mp4; codecs="avc1.424028, mp4a.40.2"', 
              bitsPerSecond: 8 * Mbps,
            };
            mediaRecorder.current[index] = new MediaRecorder(stream, options);
            chunks.current[camera.deviceId] = [];
            mediaRecorder.current[index].ondataavailable = (e) => {
              if (e.data.size > 0) {
                chunks.current[camera.deviceId].push(e.data);
              }
            };
            mediaRecorder.current[index].start(100);
            setActiveRecordings((prev) => new Set(prev).add(camera.deviceId));
            setIsRecording(true);
          }
        }
      }
    });
    setRecordingStartTime(Date.now());
    startRecordingTimer();
    VideoAudio.current.play();
  };

  const stopRecording = async (cameraIds = []) => {
    const stoppingPromises = [];

    cameras.forEach((camera, index) => {
      if (
        videoRefs.current[index] &&
        (cameraIds.length === 0 || cameraIds.includes(camera.deviceId))
      ) {
        if (
          mediaRecorder.current[index] &&
          mediaRecorder.current[index].state === "recording"
        ) {
          mediaRecorder.current[index].stop();

          stoppingPromises.push(
            new Promise((resolve) => {
              mediaRecorder.current[index].onstop = async () => {
                const blob = new Blob(chunks.current[camera.deviceId], {
                  type: "video/webm",
                });

                //TODO: need to thing of a diffferent way to do this
                //const watermarkedBlob = await addWatermarkToVideo(blob);
                resolve({ cameraId: camera.deviceId, videoBlob: blob});
              };
            })
          );

          mediaRecorder.current[index] = null;
          setActiveRecordings((prev) => {
            const newSet = new Set(prev);
            newSet.delete(camera.deviceId);
            return newSet;
          });
        }
      }
    });

    const newRecordedVideos = await Promise.all(stoppingPromises);
    setRecordedVideos((prevVideos) => [...prevVideos, ...newRecordedVideos]);
    setActiveRecordings((prev) => {
      if (prev.size === 0) {
        setIsRecording(false);
        clearRecordingTimer();
      }
      return prev;
    });

    const mediaData = newRecordedVideos.map((video) => ({
      cameraId: video.cameraId,
      type: "video",
      blob: video.videoBlob,
      fileName: `ppg`,
    }));

    if (mediaData.length > 0) {
      await uploadMedia(mediaData);
    }
  };
  const startRecordingTimer = () => {
    recordingTimerRef.current = setTimeout(() => {
      showRecordingAlert();
    }, 10 * 60 * 1000);
  };

  const clearRecordingTimer = () => {
    if (recordingTimerRef.current) {
      clearTimeout(recordingTimerRef.current);
    }
    if (alertTimerRef.current) {
      clearTimeout(alertTimerRef.current);
    }
    setRecordingStartTime(null);
  };
  const showRecordingAlert = () => {
    showAlert(
      "Recording Time Limit Reached",
      "You’ve been recording for over 10 minutes. To avoid unnecessary recording, the session will auto-stop in 10 seconds unless you choose to continue",
      "warning",
      "Continue Recording",
      "Stop Recording",
      10000,
      true,
      false,
      true
    ).then((result) => {
      if (result.dismiss === Swal.DismissReason.timer || result.isDismissed) {
        stopAllRecordings();
      } else if (result.isConfirmed) {
        startRecordingTimer();
      }
    });
  };

  useEffect(() => {
    return () => {
      clearRecordingTimer();
    };
  }, []);
const uploadMedia = async (mediaData) => {
    try {
      setLoading(true);
      const response = await GENERATE_ORDER_MEDIA_PRESIGNEDURL(mediaData);
      const urls = response.data;
      const uploadPromises = mediaData.map(async (media, index) => {
        const { signedUrl, key } = urls[index];
        Swal.fire({
          title: "Uploading...",
          html: '<div style="width: 100%; background: #e0e0e0; border-radius: 8px;">' +
                '<div id="progress-bar" style="height: 20px; width: 0%; background: #76c7c0; border-radius: 8px;"></div>' +
                '</div>',
          toast: true,
          position: "top-right",
          showConfirmButton: false,
          allowOutsideClick: false,
        });

        const uploadResponse = await axios.put(signedUrl, media.blob, {
          headers:{
            "Content-Type": media.blob.type,
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            const progressBar = document.getElementById("progress-bar");
          if (progressBar) {
            progressBar.style.width = `${percentCompleted}%`;
          }
          },
        });

        if (uploadResponse.status !== 200) {
          throw new Error(`Failed to upload media ${index} to presigned URL. Status: ${uploadResponse.status}`);
        }
        const mediaMetadata = {
          order_id: currentOrder.id,
          type: "order_media",
          media: {
            type: media.type,
            url: urls[index].fileUrl,
            key: key
          },
        };
        const metadataResponse = await UPLOAD_ORDER_MEDIA_METADATA(mediaMetadata);
        if (!metadataResponse?.status === 200) {
          throw new Error(`Failed to upload metadata for media ${index}`);
        }
        return mediaMetadata;
      });
      await Promise.all(uploadPromises);
      showToast("Media uploaded successfully", "success");
      setMediaUploaded(true);
      if (storeStatus?.ai_active && mediaData[0].type === "image") {
        try {
          const formData = new FormData();
          formData.append("image", mediaData[0].blob);
          formData.append("orderData", JSON.stringify(currentOrder));
          const verifyProduct = await VERIFY_PRODUCTS(formData);
          if (verifyProduct?.data?.status) {
            const productsToAdd = verifyProduct.data.status
              .filter((item) => item.quantity > 0)
              .map((item) => item.product_id);
            setProductVerified((prevVerified) => {
              const newProducts = productsToAdd.filter((id) => !prevVerified.includes(id));
              return [...prevVerified, ...newProducts];
            });
          }
        } catch (verifyError) {
          console.error("Error verifying products:", verifyError);
        }
      }
    } catch (error) {
      console.error("Error uploading media:", error);
      showToast(error.message || "Failed to upload media", "error");
      setMediaUploaded(false);
    } finally {
      setLoading(false);
    }
  };
 
  const copyOrderIdToClipboard = async (order_name) => {
    try {
      await navigator.clipboard.writeText(order_name);
      return true;
    } catch (err) {
      console.error("Failed to copy order ID:", err);
      return false;
    }
  };

  const markAsPacked = async () => {
    if (!isLocationSelected || selectedLocation === "Select the location" || selectedLocation === "Select a location") {
      showAlert(
        "Location Required",
        "Please select a warehouse location before marking the order as packed.",
        "warning",
        "OK",
        null,
        0,
        false,
        false,
        false
      );
      return;
    }
    try {
      if (activeRecordings.size > 0) {
        await stopAllRecordings();
      }
      setLoading(true);
      const requestBody = {
        order_id: currentOrder.id,
        products: selectedProducts,
        tote_code: currentToteCode,
      };
      if (tagId) {
        requestBody.tag_id = tagId;
      }
      const response = await PACK_ORDERS(requestBody);
      if (response.status === 200) {
        const copySuccess = await copyOrderIdToClipboard(currentOrder.name);       
        setCanSearchNewOrder(true);
        setCapturedPhotos([]);
        setNewCapturedPhotos([]);
        setRecordedVideos([]);
        setCurrentOrder(null);
        setSearchInput("");
        setSelectedProducts([]);
        setScannedBarcode("");
        setActiveBarcode(null);
        setActiveRecordings(new Set());
        setIsRecording(false);
        setIsPackingInProgress(false);
        setCurrentToteCode(null);
        clearRecordingTimer();

        Swal.fire({
          icon: "success",
          title: "Order Packed",
          text: "Order marked as packed successfully.",
          confirmButtonColor: "#3085d6",
        });
        if (copySuccess) {
          showToast("Order ID copied to clipboard!", "success");
        }
      } else {
        throw new Error(response.data.message || "Error packing order");
      }
    } catch (error) {
      console.error("Error in markAsPacked:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "There was an error marking the order as packed. Please try again.",
        confirmButtonColor: "#3085d6",
      });
    } finally {
      setLoading(false);
    }
  };
  
  const handleRemoveAll = async () => {
    const confirmRemoveAll = await Swal.fire({
      icon: "warning",
      title: "Are you sure?",
      text: "This action will remove all media associated with this order. This cannot be undone.",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, remove all media!",
    });
  
    if (confirmRemoveAll.isConfirmed) {
      try {
        const response = await DELETE_ALL_ORDER_MEDIA(currentOrder.id);
  
        if (response.status === 200) {
          const updatedOrderResponse = await FETCH_ORDER_DETAILS(
            currentOrder.order_number
          );
          
          if (updatedOrderResponse.status === 200) {
            setCurrentOrder(updatedOrderResponse.data.data);
            
            Swal.fire({
              icon: "success",
              text: "All media removed successfully.",
            });
          } else {
            Swal.fire({
              icon: "error",
              text: "Error updating order details after removing media",
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            text: response.data.message || "Error removing media",
          });
        }
      } catch (err) {
        console.log(err);
        Swal.fire({
          icon: "error",
          text: "An error occurred while removing media.",
        });
      }
    }
  };

  const handleDelete = async (mediaId) => {
    const confirmDelete = await Swal.fire({
      icon: "warning",
      title: "Are you sure?",
      text: "This action cannot be undone.",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });
  
    if (confirmDelete.isConfirmed) {
      try {
        const response = await DELETE_SINGELORDER_MEDIA(mediaId);  
        if (response.status === 200) {
          const updatedOrderResponse = await FETCH_ORDER_DETAILS(
            currentOrder.order_number
          );          
          if (updatedOrderResponse.status === 200) {
            setCurrentOrder(updatedOrderResponse.data.data);
            
            Swal.fire({
              icon: "success",
              text: "Media deleted successfully.",
            });
          } else {
            Swal.fire({
              icon: "error",
              text: "Error updating order details after deletion",
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            text: response.data.message || "Error deleting media",
          });
        }
      } catch (err) {
        Swal.fire({
          icon: "error",
          text: "Network error deleting media",
        });
      }
    }
  };

  const handleManualCapture = (selectedCameras) => {
    capturePhoto(selectedCameras);
  };

  const handleManualRecording = (selectedCameras) => {
    if (activeRecordings.size > 0) {
      stopRecording(Array.from(activeRecordings));
    } else {
      startRecording(selectedCameras);
    }
  };
  useEffect(() => {
    if (loading) {
      message.warning("Loading...");
    } else {
      message.destroy();
    }
  }, [loading]);
  return (
    <>
      <div className={styles.section} style={{ marginBottom: "120px" }}>
        <div className={styles.row}>
          <div className={styles.col}>
            <>
              <OrderLineItems
                productVerified={productVerified}
                orderData={currentOrder}
                setCurrentOrder={setCurrentOrder}
                onSelectionChange={(selectedProducts) => {
                  setSelectedProducts(selectedProducts);
                }}
                scannedBarcode={scannedBarcode}
                setIsPackingInProgress={setIsPackingInProgress}
                storeStatus={storeStatus}
              />
            </>
          </div>
          <div className={styles.col}>
            <Card
              className={cn(styles.card)}
              title="Orders"
              classTitle={cn("title-purple", styles.title)}
              classCardHead={cn(styles.head)}
              head={
                <>
                  <Form
                    className={styles.form}
                    value={searchInput}
                    setValue={setSearchInput}
                    placeholder={
                      canSearchNewOrder
                        ? "Scan order or tote"
                        : "Scan item barcode or action barcode"
                    }
                    type="text"
                    name="search"
                    icon="search"
                    autoFocus={true}
                    onSubmit={handleSearch}
                  />
                  {activeRecordings.size > 0 && (
                    <Image
                      className="h-[25px] w-[60px] ml-[10px]"
                      srcDark={Record}
                      src={Record}
                      alt="Record"
                    />
                  )}
                  <Dropdown
                    className={styles.locationDropdown}
                    value={selectedLocation}
                    setValue={handleLocationChange}
                    options={[
                      "Select a location",
                      ...locations.map((location) => location.name),
                    ]}
                    error={
                      selectedLocation === 'Select the location' 
                        ? <div className="flex items-center gap-2">
                            <Icon name="note_info" size="16" /> 
                            <span>Please select a warehouse to continue.</span>
                          </div>
                        : ""
                    } 
                  />
                </>
              }
            >
              <div className="flex flex-wrap gap-[15px]">
                {cameras.map((camera, index) => (
                  <div key={camera.id}>
                    <p className="mb-[15px]">{camera.name}</p>
                    {camera.deviceId ? (
                      <>
                        <video
                          ref={(el) => (videoRefs.current[index] = el)}
                          width="275"
                          height="273"
                          autoPlay
                          muted
                          style={{ flex: "1 1 120px", borderRadius: "12px" }}
                        />
                        <div className="flex gap-2 justify-center mt-2 relative">
                          {currentOrder && (
                            <>
                              <button
                                onClick={() => capturePhoto([camera.deviceId])}
                                className={cn("button-stroke ", styles.button)}
                              >
                                <Icon name="photo" size="24" fill="red" />
                                Photo
                              </button>
                              {activeRecordings.has(camera.deviceId) ? (
                                <button
                                  onClick={() =>
                                    stopRecording([camera.deviceId])
                                  }
                                  className={cn(
                                    "button-stroke-recording ",
                                    styles.button
                                  )}
                                >
                                  <Icon name="recording" size="24" fill="red" />{" "}
                                  Recording
                                </button>
                              ) : (
                                <button
                                  onClick={() =>
                                    startRecording([camera.deviceId])
                                  }
                                  className={cn(
                                    "button-stroke mr-[10px]",
                                    styles.button
                                  )}
                                >
                                  <Icon
                                    name="video_icon"
                                    size="24"
                                    fill="red"
                                  />
                                  Video
                                </button>
                              )}
                            </>
                          )}
                        </div>
                      </>
                    ) : (
                      <UpdateCameraPlaceHolder
                        existingCamera={camera}
                        setCameraUpdateTrigger={setCameraUpdateTrigger}
                        onCameraUpdate={(updatedCamera) => {
                          const updatedCameras = cameras.map((c) =>
                            c.id === updatedCamera.id ? updatedCamera : c
                          );
                          setCameras(updatedCameras);
                          localStorage.setItem(
                            "Camera",
                            JSON.stringify(updatedCameras)
                          );
                        }}
                      />
                    )}
                  </div>
                ))}
                <div>
                  <div className="mb-[15px] h-[23px]"></div>
                  <CameraPlaceholder setCameraUpdateTrigger={setCameraUpdateTrigger} />
                </div>
              </div>

              {currentOrder && (
                <div className="mt-[50px]">
                  <Product
                    initialOrderMedia={currentOrder.OrderMedia}
                    currentOrderID={currentOrder.id}
                    orderNumber={currentOrder.order_number}
                    handleRemoveAll={handleRemoveAll}
                    handleDelete={handleDelete}
                    mediaUploaded={mediaUploaded}
                    setMediaUploaded={setMediaUploaded}
                  />
                </div>
              )}
            </Card>
          </div>
        </div>
        {currentOrder && (
          <div className="fixed bottom-7 left-30 right-5 ">
            <Panel
              cameras={cameras}
              handleCapture={capturePhoto}
              handleRecording={handleManualRecording}
              activeRecordings={activeRecordings}
              markAsPacked={markAsPacked}
              currentOrder={currentOrder}
            />
          </div>
        )}
      <AccessControl moduleCode="gsZHRE" requiredPrivilege="nnlrNJ">
        <Modal visible={open} onClose={() => setOpen(false)}>
          <div className={styles.details}>
            <div className={cn("title-red", styles.title)}>
              Welcome Onboard
            </div>
            <div className={styles.roww}>
              <div className={styles.coll}>
                <Divider />
                <p>
                  Hi there! It looks like you're setting up this computer for
                  the first time. Would you like to connect your cameras now?
                </p>

                <div className={cn(styles.btns)}>
                <button
                  className={cn("button-stroke pl-5 pr-5", styles.button)}
                  onClick={handleOk}
                >
                I'll do it later
                </button>
                  <button
                    className={cn("button", styles.button)}
                    onClick={handleAddCamera}
                  >
                    Yes, Connect Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        </AccessControl>
      </div>
    </>
  );
};

export default ScanOrderIndex;
